// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3UIE4","title":"Info_title__3IB8i","links":"Info_links__3476c","link":"Info_link__LxJIB","logo":"Info_logo__2mywu"};